import styles from 'styles/modules/ProfileSidebarAddress.module.scss';
import EditContent from './EditContent';
import AddContent from './AddContent';
import { useSelector } from 'react-redux';
import { companySelector } from 'store/company';
import Typo from 'components/Typo';
import { authSelector } from 'store/auth';
import LoginInfo from 'components/LoginInfo';

const ProfileSidebarAddress = (props) => {
    const {
        data: { addresses },
    } = useSelector(companySelector);
    const { isAuthenticated } = useSelector(authSelector);

    const { handleAddAddress, handleEditAddress } = props;

    let addressesItems;

    if (addresses && addresses.length > 0) {
        addressesItems = (
            <div className={styles.addressWrapper}>
                <Typo Tag="h2" variant="eyebrow" className="mb-xs">
                    Address
                </Typo>
                {isAuthenticated ? (
                    <p>{addresses[0].fullAddress}</p>
                ) : (
                    // The API sends a logged-out visitor only the city.
                    <p className={styles.locked}>
                        {/* An empty blurred bar: dummy address text in the HTML read as real data. */}
                        <span
                            aria-hidden="true"
                            className={['loginBlur', styles.placeholder].join(
                                ' '
                            )}
                        />
                        <LoginInfo label="Why is the address hidden?">
                            The full address is shown to logged-in members.
                        </LoginInfo>
                    </p>
                )}
            </div>
        );
    } else {
        addressesItems = (
            <AddContent
                data={{
                    direction: 'column',
                    label: 'Add address',
                    center: true,
                    onClick: handleAddAddress,
                }}
            />
        );
    }

    return (
        <div className={styles.wrapper}>
            {addressesItems}
            {addresses && addresses.length > 0 && (
                <div className={styles.edit}>
                    <EditContent
                        data={{
                            style: 'noLabel',
                            onClick: handleEditAddress,
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default ProfileSidebarAddress;
